import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { showUpdate, remove, update, setPaginaAtual } from './usuarioActions';
import { showNotificaoes } from './notificacoesUsuarioActions';
import SPButton from '../common/form/spButton';
import swal from 'sweetalert2';
import PermissaoUsuario from '../auth/permissao';

import ReactTableGT2A from '../common/grid/gridReactTable';

class UsuarioList extends Component {
    decodeToken = (token) => {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
            return JSON.parse(jsonPayload);
        } catch (e) { return null; }
    };

    isSelf = (rowUser) => {
        const { user } = this.props;
        if (!user || !user.token || !rowUser) return false;
        const decoded = this.decodeToken(user.token);
        const uid = decoded && String(decoded.id);
        return uid && String(rowUser.id) === uid;
    };
    
    removerUsuario(data) {
        swal({
            title: 'Deseja realmente excluir?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: 'primary',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            allowOutsideClick: 'false'
        }).then((result) => {
            if (result.value) {
                this.props.remove(data);
            }
        });
    }
    
    handlePageChange = (page) => {
        this.props.setPaginaAtual(page); 
    };

    render() {
        const usuario = this.props.list || [];
        const paginaAtual = this.props.paginaAtual;

        const columns = [
            {
                Header: 'Ações',
                Cell: row => {
                    const self = this.isSelf(row.original);
                    return (
                        <div>
                            {self ? (
                                <>
                                    <SPButton type='button' className='warning btn-sm' icon='pencil-alt' data-title='Alterar' onClick={() => this.props.showUpdate(row.original)} />
                                    <SPButton type='button' className='danger btn-sm' icon='trash-alt' disabled='disabled' />
                                    <SPButton type='button' className='info btn-sm' icon='bell' data-title='Editar Notificações' onClick={() => this.props.showNotificaoes(row.original)} />
                                </>
                            ) : (
                                <>
                                    <PermissaoUsuario tela="CadUsuario" condicao={true}>
                                        <SPButton type='button' className='warning btn-sm' icon='pencil-alt' data-title='Alterar' onClick={() => this.props.showUpdate(row.original)} />
                                        <SPButton type='button' className='danger btn-sm' icon='trash-alt' data-title='Excluir' onClick={() => this.removerUsuario(row.original)} />
                                        <SPButton type='button' className='info btn-sm' icon='bell' data-title='Editar Notificações' onClick={() => this.props.showNotificaoes(row.original)} />
                                    </PermissaoUsuario>
                                    <PermissaoUsuario tela="CadUsuario" condicao={false}>
                                        <SPButton type='button' className='warning btn-sm' icon='pencil-alt' disabled='disabled' />
                                        <SPButton type='button' className='danger btn-sm' icon='trash-alt' disabled='disabled' />
                                        <SPButton type='button' className='info btn-sm' icon='bell' disabled='disabled' />
                                    </PermissaoUsuario>
                                </>
                            )}
                        </div>
                    );
                },
                className: 'column_icon',
                width: 120,
                filterable: true,
                resizable: true,
                Filter: () => <div className='rt-th'><span >Filtrar</span></div>
            },
            {
                Header: 'Código',
                accessor: 'id',
                width: 60,
                filterable: true,
                resizable: true,
                className: 'column_grid column_center',
            },
            {
                Header: 'Nome',
                accessor: 'nome',
                className: 'column_grid',
                filterable: true,
                resizable: true,
                filterAll: true
            },
            {
                Header: 'Usuário',
                accessor: 'usuario',
                className: 'column_grid',
                filterable: true,
                filterAll: true
            },
            {
                Header: 'Grupo',
                accessor: 'grupo_idgrupo',
                className: 'column_grid',
                filterable: true,
                resizable: false,
                resizable: true,
                width: 70,
                filterAll: true
            },
            {
                Header: 'Ativo',
                accessor: 'ativo',
                width: 90,
                filterable: true,
                resizable: true,
                className: 'column_grid column_center',
                Cell: ({ value }) => {
                    switch (parseInt(value)) {
                        case 0: return 'Não'
                        case 1: return 'Sim'
                        default: return true
                    }
                },
                Cell: ({ value }) => (parseInt(value) === 1 ? "Sim" : "Não"),
                filterMethod: (filter, row) => {
                    if (!row[filter.id]) return false; 
                    const valorAtivo = parseInt(row[filter.id], 10); 
                
                    switch (filter.value) {
                        case 'Sim': return valorAtivo === 1;
                        case 'Não': return valorAtivo === 0;
                        default: return true; 
                    }
                },
                Filter: ({ filter, onChange }) =>
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%" }}
                        value={filter ? filter.value : "Todos"}
                        name='ativo'
                    >
                        <option value="Todos">Todos</option>
                        <option value="Sim">Sim</option>
                        <option value="Não">Não</option>
                    </select>
            }
        ];

        return (
            <ReactTableGT2A
                data={usuario}
                columns={columns}
                className='-striped -highlight'
                defaultPageSize={15}
                onPageChange={this.handlePageChange} 
                page={paginaAtual} 
            />
        )
    }

}

const mapStateToProps = state => ({
    list: state.usuarioCad.list,
    paginaAtual: state.usuarioCad.paginaAtual,
    user: state.auth.user
});

const mapDispatchToProps = dispatch => bindActionCreators({ showUpdate, remove, update, showNotificaoes, setPaginaAtual}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(UsuarioList)
